exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._1tHPoYCHQR7RoMSF30OoOH {\n  margin-right: 40px;\n}\n._1_wFT-79N96npYW1yvQBK_ {\n  margin: 20px;\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  grid-gap: 25px;\n}\n._1763OODDFXOMY2Qj3iTJjp {\n  display: block;\n}\n", ""]);
// Exports
exports.locals = {
	"base": "_1tHPoYCHQR7RoMSF30OoOH",
	"ProjectCardsGroup": "_1_wFT-79N96npYW1yvQBK_",
	"bevy-projectcard-cardwrapper": "_1763OODDFXOMY2Qj3iTJjp"
};